import { render } from "./RefundModal.vue?vue&type=template&id=22f7a4f0&scoped=true"
import script from "./RefundModal.vue?vue&type=script&lang=js"
export * from "./RefundModal.vue?vue&type=script&lang=js"

import "./RefundModal.vue?vue&type=style&index=0&id=22f7a4f0&scoped=true&lang=css"

import exportComponent from "/app/vue-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22f7a4f0"]])

export default __exports__